
	import {
		defineComponent,
		onMounted,
		ref
	} from 'vue';
	import {
		ReloadOutlined,
	} from '@ant-design/icons-vue';
	export default defineComponent({
		components: {
			ReloadOutlined,
		},
		props: {

		},
		setup(props, context) {
			// 声明
			let taskId = ref()
			// 页面渲染时加载
			onMounted(() => {

			})
			// 搜索查询
			const onSearch = () => {
				let searchData = {
					taskId: taskId.value
				}
				context.emit("search", searchData);
			};
			// 刷新
			const refresh = () => {
				context.emit("refresh", "ok");
			}
			return {
				refresh,
				onSearch,
				taskId

			};
		},

	});
